import { useContext } from 'react';
import { WidgetModalContext } from '../context/widget-modal-context';

export function useWidgetModal() {
  const context = useContext(WidgetModalContext);
  if (!context) {
    throw new Error('useWidgetModal must be used within WidgetModalProvider');
  }
  return context;
}

// Hook to get portal props for Chakra UI Modal
export function useWidgetPortalProps() {
  const context = useContext(WidgetModalContext);

  // If we're not in a widget context, just return empty props
  // This allows the hook to be used safely in both widget and main app contexts
  if (!context) {
    return {};
  }

  const { portalRef, isReady } = context;

  // Only return portal props if we have a valid container and it's ready
  // This prevents Chakra UI from falling back to document.body
  if (!isReady || !portalRef.current) {
    return {};
  }

  return {
    portalProps: {
      containerRef: portalRef,
    },
  };
}
